import { ICON_CLASS } from '@prophecy/icons/tokens';
import { Root } from '@radix-ui/react-tabs';
import styled from 'styled-components';
import { Button } from '../Button';
import { Stack, StackItem } from '../Layout';
import { Resizable } from '../Resizable';
import { StyledResizeIcon } from '../Resizable/styled';
import { RESIZE_HANDLE_CLASS } from '../Resizable/tokens';
import { tokens } from './tokens';
export const StyledDrawer = styled(Stack) `
  height: 100%;
`;
export const StyledDrawerHeader = styled(Stack) `
  height: ${tokens.Drawer.Header.height};
  background: ${tokens.Drawer.Header.background};
  border-top: 1px solid ${tokens.Drawer.Header.borderColor};
  border-bottom: 1px solid ${tokens.Drawer.Header.borderColor};
`;
export const StyledDrawerContent = styled(StackItem) `
  background: ${tokens.Drawer.Content.background};
  overflow: auto;
`;
export const StyledResizable = styled(Resizable) `
  position: absolute !important; // required to override inline style
  bottom: ${(props) => `${props.bottomOffset}px`};
  left: 0;
  width: 100% !important; // required to override inline style
  z-index: ${tokens.Drawer.zIndex};

  .${RESIZE_HANDLE_CLASS} {
    &:hover {
      background-color: transparent;
    }

    .${ICON_CLASS} {
      display: none;
    }
  }

  ${StyledResizeIcon} {
    color: ${tokens.Drawer.Icon.color};
  }
`;
export const DrawerTabRoot = styled(Root) `
  flex: 1;
`;
export const DrawerTab = styled(Button) `
  z-index: ${tokens.Drawer.zIndex};
  box-sizing: border-box;
  cursor: pointer;
  min-width: 95px;
  text-align: center;
  height: ${tokens.Drawer.Header.height};

  &:not(:last-child) {
    &,
    &:hover,
    &:focus,
    &[data-state='active'] {
      border-right: 1px solid ${tokens.Drawer.Header.borderColor};
    }
  }
  border-radius: 0;

  &&:hover,
  &&[data-state='active'] {
    background: ${tokens.DrawerTabHeader.Tab.active.backgroundColor};
  }
`;
export const StyledCloseButtonWrapper = styled(Stack) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${tokens.Drawer.padding};
`;
